import moment from 'moment'
import { getLastDay } from '@/lib/dateutil'
import api from '@/api'
import store from '@/store'
import { currencies } from '@/lib/code'

function getPromise(month) {
  const isCurrent = moment().format('YYYY-MM')
  const currency = currencies
    .filter((c) => c.value !== 'KRW')
    .map((c) => c.value)

  return isCurrent === month
    ? api.exchangeRate.getLatestByCodes(currency)
    : api.exchangeRate.getByCodesDate(currency, getLastDay(month))
}

function requiredMonth(months) {
  return months.filter((m) =>
    store.state.exchangeRateList.every((e) => e.month !== m)
  )
}

export async function getExchangeRate(month) {
  const months = requiredMonth(Array.isArray(month) ? month : [month])
  const res = months.map((e) => getPromise(e))

  store.dispatch('addExchangeRates', await Promise.all(res))
}

export default {
  getExchangeRate,
}
